import { render, staticRenderFns } from "./search-brand-selector.vue?vue&type=template&id=c1967950"
import script from "./search-brand-selector.vue?vue&type=script&lang=js"
export * from "./search-brand-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports